import States from 'login-constants/states';
import { Link } from 'react-router';
import * as React from 'react';
import { Field, FormProps } from 'redux-form';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import Success from 'login-components/Common/Notifications/Success/Success';
import * as cookie from 'react-cookie';

interface OldFormBodyProps extends FormProps<any, any, any> {
  successMsg?: string | false | null;
  errorMsg?: string;
  showForgotPassword: boolean;
  errorId: string;
  inputs: FormInput[];
}
export default class OldFormBody extends React.Component<OldFormBodyProps, {}> {
  render() {
    // Need to pass up a CSRF token as part of this bad boy.
    const csrfToken = cookie.load('XSRF-TOKEN');
    const { inputs, errorId, errorMsg, successMsg, showForgotPassword } = this.props;
    return (
      <div className="LoginForm-body">
        <input type="hidden" name="_csrf" value={csrfToken} />
        <fieldset className="LoginForm-fieldsWrapper">
          {inputs.map(input => (
            <Field key={input.name} {...input} />
          ))}
        </fieldset>
        <div className="LoginForm-fieldsMeta">
          {showForgotPassword && (
            <Link className="LoginForm-resetLink" id="it-ResetPasswordLink" to={States.REQUEST_RESET_PASSWORD}>
              Forgot your password?
            </Link>
          )}
          <div className="LoginForm-notificationWrapper">
            {errorMsg && <ErrorMessage errorId={errorId} errorText={errorMsg} />}
            {successMsg && <Success successText={successMsg} successId="it-LoginSuccess" />}
          </div>
        </div>
      </div>
    );
  }
}
